export default "__VITE_ASSET__C$UAGVLi__"